/*
 * @Description: 补发订单
 * @Author: gao shuai
 * @Date: 2020-05-15 18:07:30
 * @LastEditTime: 2020-05-20 18:15:40
 * @LastEditors: gao shuai
 */

import api from '../services/api';
export default {
  // 分组下拉
  async gameTeam() {
  return api({ url: '/api/ReissueRecords/GetReissueGroup', method: 'get' });
  },
  // 补发列表
  async reorderList(params) {
  return api({ url: '/api/ReissueRecords/GetReissueRecordsListAsync', method: 'get', params });
  },
  // 游戏分区下拉列表
  async gamelist(params) {
  return api({ url: '/api/SelectDropDown/GetPartitionNameListAsync', method: 'get', params });
  },
  // 清理补发记录
  async clearOrder(params) {
  return api({ url: '/api/ReissueRecords/ClearReisuueRecordAsync', method: 'post', data: params });
  },
  /* --------------------------2.订单补发-------------------------- */
  // 充值方式下拉
  async payDrow(params) {
  return api({ url: '/api/SelectDropDown/GetPayModeNameListAsync', method: 'get', params });
  },
  // 订单补发补单记录
  async orderList1(params) {
  return api({ url: '/api/OrderReissueRecords/GetOrderReissueRecordsTaskListAsync', method: 'get', params });
  },
  // 订单补发中的定时任务
  async orderList2(params) {
  return api({ url: '/api/OrderReissueRecords/GetOrderSchedulerJobsListAsync', method: 'get', params });
  },
  // 删除定时任务
  async delTask(params) {
  return api({ url: '/api/OrderReissueRecords/DeleteSchedulerJobAsync', method: 'post', data: params });
  },
  // 手动补单
  async handOrder(params) {
  return api({ url: '/api/ReissueRecords/ManualReissueAsync', method: 'post', data: params });
  },
  // 整区补单
  async allOrder(params) {
  return api({ url: '/api/ReissueRecords/AllReissueAsync', method: 'post', data: params });
  }
};
